import {Message, Loading} from 'element-ui';
import service from './service';
import socket from './websocket';
import storageM from '../storage';
import LOGIN from './config/login';
import BUSINESS from './config/business';
import SYSTEMMANAGEMENT from './config/systemManagement';
import ERP from './config/erp';
import DICTIONSAY from './config/dictionary';
import GUESTBUSINESS from './config/guestBusiness';
import LOGMANAGEMENT from './config/logManagement';
import WECHAT from './config/wechat';
import BOHUA from './config/bohua';
import resetMessage from '../components/resetMessage/resetMessage'
import $router from '../router';


const ServiceConf = {
  LOGIN,
  BUSINESS,
  ...SYSTEMMANAGEMENT,
  ERP,
  DICTIONSAY,
  GUESTBUSINESS,
  WECHAT,
  ...LOGMANAGEMENT,
  BOHUA
};

export default {
  ...socket,
  async postLoading({
                      type,
                      url,
                      params = {},
                      storageType = 'sessionStorage',
                      cache = false,
                      reflush = false,
                    }) {
    let urlKey = '';
    console.log(type, url, ServiceConf[type][url]);
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    const $loading = Loading.service({
      target: document.querySelector('div.contain'),
      lock: true,
      fullscreen: false,
      text: '请求中',
      background: 'transparent',
    });
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.post(urlKey, params);
    $loading.close();
    if (res.code === '000') {
      if (cache) {
        storage.$set({key: urlKey, parameter: res});
      }
    }
    else {
      const msg = res.msg ? res.msg : '操作异常';
      console.log('1');
      resetMessage({
        type: 'error',
        message: msg,
      })
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      }
    return res;
  },
  async postParams({
                     type,
                     url,
                     params = '',
                     storageType = 'sessionStorage',
                     cache = false,
                     reflush = false,
                   }) {
    let urlKey = '';
    console.log(type, url, ServiceConf[type][url]);
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}/${params}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.post(urlKey, params);
    if (res && res.bean && res.bean.dataDictDetails) {
      if (cache) {
        storage.$set({
          key: urlKey,
          parameter: res,
        });
      }
    }
    else {
      const msg = res.msg ? res.msg : '操作异常';
      console.log('2', res);
      resetMessage({
        type: 'error',
        message: msg,
      })
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
        }
    return res;
  },
  async postStorage({
                      type,
                      url,
                      params = '',
                      storageType = 'sessionStorage',
                      cache = false,
                      reflush = false,
                    }) {
    let urlKey = '';
    console.log(url);
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    if (cache) {
      let key = `${urlKey}?ids=${params.ids}`;
      let storageData = storage.$get({key});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.post(urlKey, params);
    if (res && res.bean) {
      if (cache) {
        let key = `${urlKey}?ids=${params.ids}`;
        storage.$set({
          key,
          parameter: res,
        });
      }
    }
    else {
      const msg = res.msg ? res.msg : '操作异常';
      resetMessage({
        type: 'error',
        message: msg,
      })
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      console.log('3');
    }
    return res;
  },
  async postUrlParams({
                        type,
                        url,
                        urlParams = '',
                        params = '',
                        storageType = 'sessionStorage',
                        cache = false,
                        reflush = false,
                      }) {
    let urlData = '';
    console.log(url);
    if (typeof urlParams === 'object') {
      Object.keys(urlParams).forEach(index => {
        urlData += `&${index}=${encodeURIComponent(urlParams[index])}`;
      });
    }
    console.log(urlData);
    urlData = urlData.substring(1);
    let urlKey = '';
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}?${urlData}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.upload(urlKey, params);
    if (res && res.bean && res.bean.dataDictDetails) {
      if (cache) {
        storage.$set({
          key: urlKey,
          parameter: res,
        });
      }
    }
    else {
      const msg = res.msg ? res.msg : '操作异常';
      res.code == '000' ? Message.success(msg) : resetMessage({
        type: 'error',
        message: msg,
      });
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      console.log('4');
    }
    return res;
  },
  async getU({
               type,
               url,
               params = {},
               storageType = 'sessionStorage',
               cache = false,
               reflush = false,
             }) {
    let urlKey = '';
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.getU(urlKey, params);
    if (res) {
      res.status = true;
      if (cache) {
        storage.$set({
          key: urlKey,
          parameter: res,
        });
      }
    }
    else {
      res.status = false;
      const msg = res.msg ? res.msg : '操作异常';
      resetMessage({
        type: 'error',
        message: msg,
      });
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      console.log('5');
    }
    return res;
  },
  async post({
               type,
               url,
               params = {},
               storageType = 'sessionStorage',
               cache = false,
               reflush = false,
             }) {
    let urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    if (urlKey.indexOf('undefined') > -1) return;
    const storage = storageM[storageType];
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.post(urlKey, params);
    if (res) {
      res.status = true;
      if (cache) {
        storage.$set({
          key: urlKey,
          parameter: res,
        });
      }
    }
    else {
      res.status = false;
      const msg = res.msg ? res.msg : '操作异常';
      resetMessage({
        type: 'error',
        message: msg,
      });
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      console.log('6');
    }
    return res;
  },
  async download({
                   type,
                   url,
                   params = {},
                 }) {
    let urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    let res = await service.download(urlKey, params);
    return res;
  },
  async postJson({
                   type,
                   url,
                   params = {},
                   storageType = 'sessionStorage',
                   cache = false,
                   reflush = false,
                 }) {
    console.log(url);
    let urlKey = '';
    if (ServiceConf[type][url]) {
      urlKey = `${ServiceConf[type]['$getway']}/${ServiceConf[type][url]}`;
    }
    else {
      return false;
    }
    const storage = storageM[storageType];
    if (cache) {
      let storageData = storage.$get({key: urlKey});
      if (storageData && !reflush) {
        return storageData;
      }
    }
    let res = await service.postJson(urlKey, params);
    if (res) {
      res.status = true;
      if (cache) {
        storage.$set({
          key: urlKey,
          parameter: res,
        });
      }
    }
    else {
      res.status = false;
      const msg = res.msg ? res.msg : '操作异常';
      resetMessage({
        type: 'error',
        message: msg,
      });
      if(res.code == 'sys005'){
        $router.push({
          path: '/login',
        });
      }
      console.log('7');
    }
    return res;
  },
  async setHeader({key, val}) {
    await service.setHeader({
      key,
      val,
    });
  },
};
